import CompleteTableData from "../../../../../../../../app/common-components/Table/CompleteTableData";
import CisBenchmarkFirstSeenConfigPopup from "../../../CisBenchmarkFirstSeenConfig/CisBenchmarkFirstSeenConfigPopup";
import React,{ memo, useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCommonAlert } from "../../../../../../../../app/utilities/helpers";
import { getSortingValues } from "../../../../../../../../app/Constants";
import {
  CisBenchmarkFirstSeenConfigList,
  saveCisBenchmarkFirstSeenConfig,
} from "../../../../ToolsSlice";
import { CISFirstSeenConfigcolumns } from "../../../../constant/Constants";

const CisBenchmarkFirstSeenConfiguration = () => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const saveLoading = useSelector(
    (state) => state.saveCisBenchmarkFirstSeenConfigLoading || false
  );

  const [state, setState] = useState({
    loading: false,
    tableData: [],
    totalCount: 0,
    pageNo: 0,
    pageLimit: 10,
    searchKey: "",
    addBodyOpenAdd: false,
    modelRowData: null,
    sortByColumn: "",
    sortOrder: "",
  });

  /* ---------- INITIAL LOAD ONLY ---------- */
  useEffect(() => {
    loadData();
  }, []);

  /* ---------- API CALL ---------- */
  const loadData = (
    pageNo = 0,
    pageLimit = 10,
    keyword = "",
    sortByColumn = "",
    sortOrder = ""
  ) => {
    setState((s) => ({ ...s, loading: true }));

    return dispatch(
      CisBenchmarkFirstSeenConfigList({
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload: { keyword, sortByColumn, sortOrder },
      })
    )
      .unwrap()
      .then((res) => {
        setState((s) => ({
          ...s,
          tableData: res?.data || [],
          totalCount: res?.totalCount || 0,
          loading: false,
        }));
      })
      .catch((err) => {
        console.error("API failed:", err);
        setState((s) => ({ ...s, loading: false }));
      });
  };

  /* ---------- MODAL ---------- */
  const addBodyOpen = useCallback((row = null) => {
    setState((prev) => ({ ...prev, addBodyOpenAdd: true, modelRowData: row }));
  }, []);

  const addBodyClose = useCallback(() => {
    setState((prev) => ({ ...prev, addBodyOpenAdd: false, modelRowData: null }));
  }, []);

  /* ---------- SAVE ---------- */
  const handleCisBenchmarkFirstSeenSave = (formData) => {
    setState((s) => ({ ...s, loading: true }));

    dispatch(saveCisBenchmarkFirstSeenConfig(formData))
      .then((data) => {
        const status = data?.payload?.statusCodeValue;

        if (status >= 200 && status < 300 && status !== 205) {
          callCommonAlert("success", data.payload.body);

          setState((prev) => ({
            ...prev,
            pageNo: 0,
            pageLimit: 10,
            searchKey: "",
            sortByColumn: "",
            sortOrder: "",
          }));

          loadData(0, 10, "", "", "").then(() => {
            addBodyClose();
            hideCommonAlert();
          });
        } else {
          if (status === 205) {
            callCommonAlert("error", data.payload.body);
          } else if (status === 409) {
            callCommonAlert("warning", data.payload.body);
          } else {
            callCommonAlert(
              "error",
              "CIS Benchmark First Seen Configuration Failed to save"
            );
          }
          hideCommonAlert();
          setState((s) => ({ ...s, loading: false }));
        }
      })
      .catch((err) => {
        console.error("Save error:", err);
        callCommonAlert(
          "error",
          "CIS Benchmark First Seen Configuration Failed to save"
        );
        hideCommonAlert();
        setState((s) => ({ ...s, loading: false }));
      });
  };

  /* ---------- TABLE ACTIONS ---------- */

  const handlePageNoChange = (pageNo) => {
    setState((prev) => ({ ...prev, pageNo }));
    loadData(pageNo, state.pageLimit, state.searchKey, state.sortByColumn, state.sortOrder);
  };

  const handleSearch = (searchValue) => {
    setState((prev) => ({ ...prev, searchKey: searchValue, pageNo: 0 }));
    loadData(0, state.pageLimit, searchValue, state.sortByColumn, state.sortOrder);
  };

  const handlePageLimitChange = (limit) => {
    setState((prev) => ({ ...prev, pageLimit: limit, pageNo: 0 }));
    loadData(0, limit, state.searchKey, state.sortByColumn, state.sortOrder);
  };

  const handleOnSorting = (column, headerSortingState) => {
    const { sortingField, isDataSorted } =
      getSortingValues(CISFirstSeenConfigcolumns, column, headerSortingState);

    setState((prev) => ({
      ...prev,
      sortByColumn: sortingField,
      sortOrder: isDataSorted,
    }));

    loadData(state.pageNo, state.pageLimit, state.searchKey, sortingField, isDataSorted);
  };

  const headerSortingState = useMemo(() => ({
    accessor: state.sortByColumn,
    isDataSorted: state.sortOrder,
  }), [state.sortByColumn, state.sortOrder]);

  const btnData = useMemo(() => [
    {
      text: "Configure",
      className: "solid-btn",
      function: () => addBodyOpen(state.tableData[0] || null),
    },
  ], [addBodyOpen, state.tableData]);

  /* ---------- UI ---------- */
  const calculatedPageCount = state.totalCount
    ? Math.ceil(state.totalCount / state.pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

  return (
    <>
      <CompleteTableData
        title="CIS Benchmark First Seen Configuration"
        TableTitle="First Seen Offset Configuration"
        isLoading={state.loading}
        data={state.tableData}
        columns={CISFirstSeenConfigcolumns}
        listCount={state.totalCount}
        pageLimit={state.pageLimit}
        curentPageNumber={state.pageNo}
        totalPageCount={finalPageCount}
        moveSearchToEnd
        onSearch={handleSearch}
        searchKey={state.searchKey}
        onPageNoChange={handlePageNoChange}
        onPageLimitChange={handlePageLimitChange}
        onSorting={handleOnSorting}
        headerSortingState={headerSortingState}
        btnData={btnData}
      />

      <CisBenchmarkFirstSeenConfigPopup
        isOpen={state.addBodyOpenAdd}
        onClose={addBodyClose}
        onSave={handleCisBenchmarkFirstSeenSave}
        initialData={state.modelRowData}
        isLoading={saveLoading}
      />
    </>
  );
};

export default memo(CisBenchmarkFirstSeenConfiguration);
